import { createAsyncAction } from "../../helpers/actions"
import { login } from "../api/login"
import { LOGIN_USER } from "../constants/ActionTypes"

export const loginUser = createAsyncAction<User, [string, string, boolean]>(
  LOGIN_USER,
  login
)
